import { RootState } from '../../../../rootReducer';

export const receiptsSelector = (state: RootState) => state.codeBankModuleReducer.ReceiptsReducer;
